// extracted by mini-css-extract-plugin
export var quillEditor = "_hz-1";
export var variable = "_hz-0";